<template>
  <div
    class="tw-text-center tw-flex-shrink-0 tw-text-black tw-text-[11px] 2xl:tw-text-[14px] tw-py-[6px] tw-px-3 xl:tw-py-[2px] 2xl:tw-py-1 2xl:tw-px-4 tw-rounded-[24px]"
    :style="`background-color: ${setColor(grade)};`">
    <nobr>
      {{ grade }}
    </nobr>
  </div>
</template>

<script>
export default {
  name: "GradeItem",
  props: {
    grade: {
      type: String,
      default: 'Partner'
    }
  },
  methods: {
    setColor(value) {
      switch (value) {
        case 'Platinum partner': return '#D0F9FF';
        case 'Gold partner': return '#FFE288';
        case 'Silver partner': return '#D7D7D7';
        case 'Bronze partner': return '#FFC978';
        case 'Sertificated partner': return '#DEFFCA';
        default: return '#D0DDFF';
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/partners/GradeItem.vue